<template>
  <div class="card-produto-carregamento">
    <!-- <div class="titulo-fluxos"> PRODUTO E CARREGAMENTO </div>
    <div class="subtitulo-fluxos"> Confira as informações do produto e forneça as datas de carregamento </div> -->

    <g-titulo-steps
    titulo="PRODUTO E CARREGAMENTO"
    subtitulo="Confira as informações do produto e forneça as datas de carregamento."
    :imagemEmpresa = imagemEmpresa
    />

    <g-form class="espacamento-fluxos">
      <div>
        <div class="codigo-produto">
          <label class="g-input-label">Código do Produto</label>
          <PInputText :disabled="true" v-model="informacoesProdutoCarregamento.CodigoProduto"></PInputText>
        </div>
        <div class="primeira-linha">
          <div class="produto">
            <label class="g-input-label">Produto</label>
            <PInputText :disabled="!verificaProdutoNovo" v-model="informacoesProdutoCarregamento.NomeProduto" maxlength="30"></PInputText>
          </div>

          <div class="condicao-pagamento">
            <label class="g-input-label">Condição de Pagamento</label>
            <PInputText :disabled="true" v-model="informacoesProdutoCarregamento.CondicaoPagamento"></PInputText>
          </div>
          <div class="quantidade-total">
            <label class="g-input-label">Quantidade Total</label>
            <PInputNumber @input="calculaPrecoSemIPI" v-model="informacoesProdutoCarregamento.QuantidadeTotal" :min="limiteQuantidadeTotal"></PInputNumber>
          </div>
          <div class="unitario">
            <label class="g-input-label">Unitário</label>

            <PInputText :disabled="true" v-model="informacoesProdutoCarregamento.ValorUnitarioFormatado" ></PInputText>
          </div>
          <div class="preco-ipi">
            <label class="g-input-label">Preço Total Sem IPI</label>
            <PInputText :disabled="true" v-model="informacoesProdutoCarregamento.ValorTotalSemIPIFormatado"></PInputText>
          </div>
          <!-- <div>
            <label class="g-input-label">Tipo de Acesso</label>
            <PInputText maxlength="10" :disabled="codigoAcessoBloqueado === true" v-model="informacoesProdutoCarregamento.CodigoAcesso"></PInputText>
          </div> -->
        </div>
        <div class="adicionar">
          <div class="titulo-grupo-detalhes">Carregamento</div>
          <div class="botaoContainer">
            <g-button
              altura="20px"
              largura="15px"
              somenteIcone
              :sombreado="false"
              cor="#RRGGBBAA"
              @click="adicionarDataCarregamento()"
              :icone="'pi pi-plus-circle'"
              :corIcone="'#fbc02d'"
              tamanhoIcone="15px"
              class="botao-adicionar">
            </g-button>
            <p class="texto-adicionar" @click="adicionarDataCarregamento()">ADICIONAR</p>
          </div>
        </div>
        <div class="linhas-carregamento">
          <div class="linha-carregamento-item" v-for="(dataCarregamento, index) in datasCarregamento" :key="index">
            <div class="data-carregamento">
              <div class="campo-obrigatorio">
                <label class="g-input-label">Data de Carregamento</label>
                <div class="red">*</div>
              </div>
              <g-date-input
                largurainput="100%"
                alturainput="100%"
                placeholderinput=""
                invertido
                :DataMaxima="dataMaxima"
                :DataMinima="dataMinima"
                v-model="dataCarregamento.DataCarregamento"
                :key="keyDataEntregaPedido"
                @change = "VerificarDataDigitada(dataCarregamento.DataCarregamento, index)"
              ></g-date-input>
            </div>
            <div class="quantidade">
              <div class="campo-obrigatorio">
                <label class="g-input-label">Quantidade</label>
                <div class="red">*</div>
              </div>
              <PInputNumber  v-model="dataCarregamento.Quantidade"></PInputNumber>
            </div>
            <div class="ordem-compra">
              <div class="campo-obrigatorio">
                <label class="g-input-label">Ordem de Compra</label>
                <div v-if="clienteOrdemCompra" class="red">*</div>
              </div>
              <PInputText v-model="dataCarregamento.OrdemDeCompra" maxlength="16"></PInputText>
            </div>
            <!-- <div class="observacao-grid">
              <label class="g-input-label">Observação</label>
              <PInputText v-model="dataCarregamento.Observacao"></PInputText>
            </div> -->
            <div class="botao-remover-data-carregamento">
              <g-button
                @click="deletarDataCarregamento(index)"
                class="trash-box"
                tipo="cinza"
                altura="35px"
                largura="45px"
                icone="icone_lixo.svg"
                tamanhoIcone="15px"
                somenteIcone
                :sombreado="false"
                v-tooltip="'Limpar filtro'"
              />
            </div>
          </div>
        </div>

        <div class="titulo-grupo-detalhes">Definição de Produção</div>
        <div class="linha-producao">
          <div class="definicao-producao">
            <label class="g-input-label">Definição de Produção</label>
            <PDropDown
              :options="definicaoDeProducaoArray"
              optionValue="enum"
              optionLabel="text"
              :disabled="tipoPedido === 1"
              v-model="informacoesProdutoCarregamento.DefinicaoPedido"
              @change="limpaCamposDefinicaoProducao"
            />
          </div>
          <div v-if="true" class="pedido">
            <div class="campo-obrigatorio">
              <label class="g-input-label">Pedido</label>
              <div v-if="(informacoesProdutoCarregamento.DefinicaoPedido === 2 || informacoesProdutoCarregamento.DefinicaoPedido === 3) || tipoPedido !== 1" class="red">*</div>
            </div>
            <PInputText
              :disabled="
              (informacoesProdutoCarregamento.DefinicaoPedido === 0 ||
              informacoesProdutoCarregamento.DefinicaoPedido === 1 ||
              informacoesProdutoCarregamento.DefinicaoPedido === 4 ||
              informacoesProdutoCarregamento.DefinicaoPedido === 5 ||
              tipoPedido === 1) ? true : false"
              v-model="informacoesProdutoCarregamento.CodigoPedidoDefinicao"
            />
          </div>
          <div v-if="true" class="observacao">
            <div class="campo-obrigatorio">
              <label class="g-input-label">Observação</label>
              <div v-if="(informacoesProdutoCarregamento.DefinicaoPedido !== 4 && informacoesProdutoCarregamento.DefinicaoPedido !== 5) || tipoPedido !== 1" class="red">*</div>
            </div>
            <PInputText
            :disabled="(informacoesProdutoCarregamento.DefinicaoPedido === 4 || informacoesProdutoCarregamento.DefinicaoPedido === 5 || tipoPedido === 1) ? true : false"
            v-model="informacoesProdutoCarregamento.ObservacaoDefinicao"
            />
          </div>
        </div>
        <div class="titulo-grupo-detalhes">Componentes</div>

        <div v-if="!this.componentes || this.componentes.length === 0" class="flex-container">
          <div class="info-conteudo"> Não possui componentes </div>
        </div>


        <div  v-else class="lado_a_lado" v-for="(data, index) in componentes" :key="index">
          <div class="componentes-geral">
            <div class="grupo-numero-componentes">
              <div>
                <div class="numero label-conteudo">{{ data.numeroComponente }}</div>
              </div>
            </div>


        <div class="linha-componentes" >
          <div class="componentes-componentes">
            <div class="componentes titulo-conteudo-detalhes"> Componente </div>
            <div class="componentes label-conteudo">{{ data.componenteTipoTexto }}</div>
          </div>

          <div class="componentes-medidas">
            <div class="medidas titulo-conteudo-detalhes"> Medidas </div>
            <div class="medidas label-conteudo">{{ (data.numeroComprimento != 0) && (data.numeroLargura != 0)   ? data.ColunaMedidas : data.descricaoMedidasTexto }}</div>
          </div>

          <div class="componentes-cor-frente">
            <div class="corFrente titulo-conteudo-detalhes"> Cor Frente </div>
            <div class="corFrente label-conteudo">{{ data.descricaoCoresFrenteTexto }}</div>
          </div>

          <div class="componentes-cor-verso">
            <div class="corVerso titulo-conteudo-detalhes"> Cor Verso </div>
            <div class="corVerso label-conteudo">{{ data.descricaoCoresVersoTexto }}</div>
          </div>

          <div class="componentes-acabFrente">
            <div class="acabFrente titulo-conteudo-detalhes"> Acabamento Frente </div>
            <div class="acabFrente label-conteudo">{{ data.descricaoAcabamentoFrenteTexto }}</div>
          </div>

          <div class="componentes-acabVerso">
            <div class="acabVerso titulo-conteudo-detalhes"> Acabamento Verso </div>
            <div class="acabVerso label-conteudo">{{ data.descricaoAcabamentoVersoTexto }}</div>
          </div>

          <div class="componentes-material">
            <div class="material titulo-conteudo-detalhes"> Material </div>
            <div class="material label-conteudo">{{ data.descricaoMaterialTexto }}</div>
          </div>

          <div class="componentes-onda">
            <div class="onda titulo-conteudo-detalhes"> Onda </div>
            <div class="onda label-conteudo">{{ data.descricaoOndaTexto }}</div>
          </div>

          <div class="componentes-capaExt">
            <div class="capaExt titulo-conteudo-detalhes"> Capa Externa </div>
            <div class="capaExt label-conteudo">{{ data.descricaoCapaExternaTexto }}</div>
          </div>

          <div class="componentes-gramaturaExt">
            <div class="gramaturaExt titulo-conteudo-detalhes"> Gramatura Capa Externa</div>
            <div class="gramaturaExt label-conteudo">{{ data.numeroGramaturaCapaExterna }}</div>
          </div>

          <div class="componentes-papelOnda">
            <div class="papelOnda titulo-conteudo-detalhes"> Papel de Onda </div>
            <div class="papelOnda label-conteudo">{{ data.descricaoPapelOndaTexto }}</div>
          </div>

          <div class="componentes-gramaturaPO">
            <div class="gramaturaPO titulo-conteudo-detalhes"> Gramatura Papel de Onda</div>
            <div class="gramaturaPO label-conteudo">{{ data.numeroGramaturaPapelOnda }}</div>
          </div>

          <div class="componentes-capaInt">
            <div class="capaInt titulo-conteudo-detalhes"> Capa Interna </div>
            <div class="capaInt label-conteudo">{{ data.descricaoCapaInternaTexto }}</div>
          </div>

          <div class="componentes-gramaturaInt">
            <div class="gramaturaInt titulo-conteudo-detalhes"> Gramatura Capa Interna</div>
            <div class="gramaturaInt label-conteudo">{{ data.numeroGramaturaCapaInterna }}</div>
          </div>

          <!-- <div class="componentes-sistema">
            <div class="sistema titulo-conteudo-detalhes"> Sistema </div>
            <div class="sistema label-conteudo">{{ data.sistemaTexto }}</div>
          </div>           -->

          <div>
              <div class="componentes-codigo">
                  <div class="titulo-conteudo-resumo-final"> Código Sistema</div>
                  <div class="label-conteudo-resumo-final">{{data.codigoSistema}}</div>
              </div>
          </div>

              <div>
                <div class="componentes-codigo">
                  <div class="titulo-conteudo-resumo-final"> Descrição Sistema</div>
                  <div class="label-conteudo-resumo-final">{{data.sistema}}</div>
                </div>

              </div>

             <div v-if="data.descricaoSistema == 2">
                <div class="componentes-codigo">
                  <div class="titulo-conteudo-resumo-final"> Produto </div>
                  <div class="label-conteudo-resumo-final">{{data.produtoSistema}}</div>
              </div>
            </div>

            <div v-if="data.descricaoSistema == 3">
                <div class="componentes-codigo">
                  <div class="titulo-conteudo-resumo-final"> Protótipo </div>
                  <div class="label-conteudo-resumo-final">{{data.prototipoSistema}}</div>
            </div>
          </div>

          <div class="componentes-embalagem-coletiva"
                    v-if="data.embalagemPalete == true ||
                            data.embalagemFilmeEncolhivel == true ||
                            data.embalagemCaixaColetiva == true ||
                            data.embalagemPapelEmbrulho == true || data.quantidadeOutros != 0">
                        <div class="titulo-conteudo-detalhes"> Embalagem Coletiva </div>
                        <div class="label-conteudo" v-for="(texto, index) in data.embalagens" :key="index">
                                {{ texto }}
                        </div>
                    </div>



          <!-- <div class="componente">
            <div class="titulo-conteudo-detalhes">Componente</div>
            <div class="info-conteudo">{{componente.componenteTipoTexto}}</div>
          </div>

          <div class="medidas">
            <div class="titulo-conteudo-detalhes">Medidas</div>
            <div class="info-conteudo">{{ temDescricaoMedidas ? componente.descricaoMedidas : componente.medidas}}</div>
          </div>

          <div class="material">
            <div class="titulo-conteudo-detalhes">Material</div>
            <div class="info-conteudo">{{componente.descricaoMaterialTexto}}</div>
          </div>

          <div class="onda">
            <div class="titulo-conteudo-detalhes">Onda</div>
            <div class="info-conteudo">{{componente.descricaoOndaTexto}}</div>
          </div>

          <div class="capaExterna">
            <div class="titulo-conteudo-detalhes">Capa Externa</div>
            <div class="info-conteudo">{{componente.descricaoCapaExternaTexto}}</div>
          </div>

          <div class="capaExterna">
            <div class="titulo-conteudo-detalhes">Gramatura Capa Externa</div>
            <div class="info-conteudo">{{componente.numeroGramaturaCapaExterna}}</div>
          </div>

          <div class="papel">
            <div class="titulo-conteudo-detalhes">Papel de Onda</div>
            <div class="info-conteudo">{{componente.descricaoPapelOndaTexto}}</div>
          </div>

          <div class="capaExterna">
            <div class="titulo-conteudo-detalhes">Gramatura</div>
            <div class="info-conteudo">{{componente.numeroGramaturaPapelOnda}}</div>
          </div>

          <div class="capaInterna">
            <div class="titulo-conteudo-detalhes">Capa Interna</div>
            <div class="info-conteudo">{{componente.descricaoCapaInternaTexto}}</div>
          </div>

          <div class="capaExterna">
            <div class="titulo-conteudo-detalhes">Gramatura Capa Interna</div>
            <div class="info-conteudo">{{componente.numeroGramaturaCapaInterna}}</div>
          </div>

          <div class="corFrente">
            <div class="titulo-conteudo-detalhes">Cor da Frente</div>
            <div class="info-conteudo">{{componente.descricaoCoresFrenteTexto}}</div>
          </div>

          <div class="corVerso">
            <div class="titulo-conteudo-detalhes">Cor do Verso</div>
            <div class="info-conteudo">{{componente.quantidadeCoresVerso}}</div>
          </div>

          <div class="acabamentoFrete">
            <div class="titulo-conteudo-detalhes">Tipo de Acabamento da Frente</div>
            <div class="info-conteudo">{{componente.descricaoAcabamentoFrenteTexto}}</div>
          </div>

          <div class="acabamentoVerso">
            <div class="titulo-conteudo-detalhes">Tipo de acabamento do Verso</div>
            <div class="info-conteudo">{{ componente.descricaoAcabamentoVersoTexto }}</div>
          </div>

          <div class="sistema">
            <div class="titulo-conteudo-detalhes">Sistema</div>
            <div class="info-conteudo">{{ componente.descricaoSistemaTexto }}</div>
          </div> -->


          <!-- <div class="embalagemColetiva">
            <div class="titulo-conteudo-detalhes">Embalagem Coletiva</div>
            <div class="info-conteudo">Caixa Coletiva (200)</div>
          </div> -->

        </div>
      </div>
        </div>
      </div>
    </g-form>
  </div>

  <div class="buttons-next-back">
    <div class="button-next">
      <g-button
      tipo="amarelo"
      altura="35px"
      largura="100%"
      negritoTexto
      @click="Continuar()"
      ref="botaoContinuar"
      >
        CONTINUAR
      </g-button>
    </div>
    <div class="button-back">
      <g-button
      tipo="cinza"
      altura="35px"
      largura="100%"
      negritoTexto
      @click="voltar()"
      >
        VOLTAR
      </g-button>
    </div>
  </div>
</template>

<script>
import ProdutoCarregamento from "./ProdutoCarregamento.js";
export default ProdutoCarregamento;
</script>

<style scoped>

.codigo-produto {
    width: 200px;
}
.componentes-geral{
    display: flex;
    gap: 1rem;
    border-bottom: 2px solid #c4bfbf4d;
}
.grupo-numero-componentes{
    margin: auto;
    flex: 1;
    text-align: center;
    justify-content: center;
    align-items: center;

}
.titulo-conteudo-detalhes{
  display: flex;
  align-items: left;
  color: #3e3e3e;
  text-align: left;
  font-size: 15px !important;
  font-family: "MontSerrat";
  font-weight: bold;
  margin-bottom: 3px;
  text-overflow: ellipsis;
  overflow: hidden;
}
.botao-remover-data-carregamento{
  display: flex;
  justify-content: center;
  align-items: end;
  margin: 1rem 0;
}

.botaoContainer {
  display: flex;
  align-items: baseline;
  justify-content: end;
  border-bottom: 1px solid #f0f0f0;
}
.adicionar {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  align-items: baseline;
}

.p-inputnumber {
  width: 100%;
  display: inline-flex;
}
.p-dropdown {
  background: #ffffff;
  border: 1px solid #ced4da;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s,
    box-shadow 0.2s;
  border-radius: 3px;
  width: 100%;
}

.flex-container {
  display: flex;
  justify-content: flex-start;
  margin-top: 1rem;
}

.info-conteudo {
  font-family: "MontSerrat";
  color: #8a8a8a;
  font-size: 16px;
  text-align: initial;
}

.titulostep2 {
  margin-top: 50px;
  font-family: "MontSerrat";
  color: #4f2c19;
  font-size: 17px;
  font-weight: bold;
  display: flex;
}

.linha-producao {
  display: flex;
  gap: 2%;
}

.texto-adicionar {
  font: normal normal 600 13px/23px Montserrat;
  color: #4f2c19;
  text-decoration: underline;
  margin-top: 5px;
  margin-left: 5px;
  align-items: baseline;
}

.texto-adicionar:hover{
  cursor: pointer;
}

.g-input-label {
  display: flex;
  align-items: left;
  color: #3e3e3e;
  text-align: left;
  font-size: 15px !important;
  font-family: "MontSerrat";
  font-weight: bold;
  margin: 0 0 1px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.p-inputtext {
  width: 100%;
}

.outrosubtitulo {
  margin-top: 10px;
  font-family: "MontSerrat";
  color: #8a8a8a;
  font-size: 16px;
}

.titulostep {
  margin-top: 15px;
  font-family: "MontSerrat";
  color: #4f2c19;
  font-size: 20px;
  font-weight: bold;
}

.campo-obrigatorio {
  display: flex;
  align-items: baseline;
}

.red {
  margin-left: 5px;
  color: red;
}

@media (min-width: 310px) {
  .titulo-grupo-detalhes{
    padding: 30px 0 15px;
  }
  .botoes {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr;
    gap: 10px;
    margin-top: 10%;
  }

  .botaoContinuar {
    grid-area: 1/1/2/2;
    justify-self: center;
    width: 100%;
  }

  .botaoVoltar {
    grid-area: 2/1/3/2;
    justify-self: center;
    width: 100%;
  }
  .linha-producao {
    display: block;
    /* grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr 1fr;
    gap: 0%; */
  }
  .definicao-producao {
    grid-area: 1/1/2/2;
    width: auto;
  }
  .pedido {
    grid-area: 2/1/3/2;
    width: auto;
  }
  .observacao {
    grid-area: 3/1/4/2;
    width: auto;
  }
  .linha-carregamento-item {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(3, 1fr);
    gap: 0%;
  }

  .segunda-linha-carregamento {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(3, 1fr);
    gap: 0%;
  }

  .data-carregamento {
    grid-area: 1/1/2/2;
    width: auto;
  }
  .quantidade {
    grid-area: 2/1/3/2;
    width: auto;
  }
  .ordem-compra {
    grid-area: 3/1/4/2;
    width: auto;
  }

  .primeira-linha {
    display: grid;
    grid-template-columns: 1fr;
    /* grid-template-rows: repeat(7, 1fr); */
    gap: 0%;
  }

  .produto {
    grid-area: 2/1/3/2;
    width: auto;
  }
  .codigo-produto {
    grid-area: 1/1/2/2;
  }
  .tipo-acesso {
    grid-area: 3/1/4/2;
  }
  .condicao-pagamento {
    grid-area: 4/1/5/2;
  }
  .quantidade-total {
    grid-area: 5/1/6/2;
  }
  .unitario {
    grid-area: 6/1/7/2;
  }
  .preco-ipi {
    grid-area: 7/1/8/2;
  }

  .linha-componentes {
    margin-top: 1.25rem;
    padding-bottom: 1.25rem;
    border-bottom: 1px solid #e1e1e1;
    display: grid;
    grid-template-columns: repeat(2, minmax(4em, 1fr));
    grid-template-rows: repeat(12, auto);
    column-gap: 3%;
    justify-items: start;
    flex: 15
  }

  .linha-componentes:last-child{
    border-bottom: none;
    padding-bottom: 0;
  }
}

@media (min-width: 368px) {
  .linha-componentes {
    display: grid;
    grid-template-columns: repeat(1, minmax(4em, 1fr));
    grid-template-rows: repeat(12, auto);
    column-gap: 3%;
  }
}

@media (min-width: 600px) {
  .linha-componentes {
    display: grid;
    grid-template-columns: repeat(2, minmax(4em, 1fr));
    grid-template-rows: repeat(6, auto);
    column-gap: 3%;
  }
}

@media (min-width: 801px) {
  .botoes {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
    margin-top: 5%;
    grid-gap: 20px;
  }

  .botaoContinuar {
    grid-area: 1/2/2/3;
    justify-self: left;
    width: 40%;
  }

  .botaoVoltar {
    grid-area: 1/1/2/2;
    justify-self: end;
    width: 40%;
  }
  .data-carregamento {
    width: 40%;
  }
  .quantidade {
    width: 30%;
  }
  .ordem-compra {
    width: 40%;
  }
  .definicao-producao {
    width: 30%;
  }
  .pedido {
    width: 15%;
  }
  .observacao {
    width: 15%;
  }
  .linha-producao {
    display: flex;
    gap: 2%;
  }
  .linha-carregamento-item {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, 1fr);
    column-gap: 10%;
  }

  .data-carregamento {
    grid-area: 1/1/1/1;
    width: auto;
  }
  .quantidade {
    grid-area: 1/2/1/2;
    width: auto;
  }
  .ordem-compra {
    grid-area: 2/1/2/2;
    width: auto;
  }

  .observacao-grid {
    grid-area: 2/2/2/3;
  }

  .botao-remover-data-carregamento{
    grid-area: 2/3/2/4;
    width: auto;
  }

  .linha-componentes {
    display: grid;
    grid-template-columns: repeat(2, minmax(4em, 1fr));
    grid-template-rows: repeat(4, auto);
    column-gap: 3%;
  }
}

@media (min-width: 1025px) {
  .linha-componentes {
    display: grid;
    grid-template-columns: repeat(2, minmax(4em, 1fr));
    grid-template-rows: repeat(3, auto);
    column-gap: 3%;
  }
  .titulo-grupo-detalhes{
    padding: 30px 0 14px;
  }
  .primeira-linha {
    display: grid;
    grid-template-columns: 0.25fr 0.5fr 0.5fr 1fr;
    grid-template-rows: 1fr 1fr;
    gap: 2%;
  }

  .produto {
    grid-area: 1/1/2/4;
    width: 100%;
  }

  /* .codigo-produto {
    grid-area: 1/1/2/2;
    width: 100%;
  } */

  .tipo-acesso {
    grid-area: 1/3/2/4;
    width: 100%;
  }

  .condicao-pagamento {
    grid-area: 1/4/2/5;
    width: 100%;
  }

  .quantidade-total {
    grid-area: 2/1/3/3;
    width: 100%;
  }

  .unitario {
    grid-area: 2/3/3/4;
    width: 100%;
  }

  .preco-ipi {
    grid-area: 2/4/3/5;
    width: 100%;
  }

  .botao-remover-data-carregamento{
    margin: 0.5rem 0;
  }

}

@media (min-width: 1281px) {

  .linha-carregamento-item {
    grid-template-rows: 1fr;
    grid-template-columns: 1fr 1fr 1fr 0.25fr;
  }

.data-carregamento {
    grid-area: 1/1/1/1;
    width: auto;
  }
  .quantidade {
    grid-area: 1/2/1/2;
    width: auto;
  }
  .ordem-compra {
    grid-area: 1/3/1/3;
    width: auto;
  }

  .observacao-grid {
    grid-area: 1/4/1/4;
  }

  .botao-remover-data-carregamento{
    grid-area: 1/4/1/4;
    width: auto;
  }

}

@media (min-width: 1500px) {
  .linha-componentes {
    display: grid;
    grid-template-columns: repeat(2, 0.4fr);
    grid-template-rows: repeat(3, auto);
    column-gap: 3%;
  }
}

</style>
